module.exports = __webpack_public_path__ + "static/media/ChatTeardrop.f02bf351.svg";